import abstractModel from "../../core/MercatelyModel";
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/team_assignments`;

const model = abstractModel(resource);

model.getFor = async (platform) => {
  const newResource = `${resource}/for_${platform}`;

  return model.get({}, { path: newResource });
};

model.getForAll = async () => {
  const newResource = `${resource}/for_all`;

  return model.get({}, { path: newResource });
};

export default model;
